import React from "react";

import { formatBrazilianCurrency } from "shared/utils/formatBrazilianCurrency";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";
import InformationCircleSVG from "@payment/assets/InformationCircleSVG";

import DiscountInformation from "../DiscountInformation";
import {
  Discount,
  DiscountContainer,
  LittleLetters,
  Paragraph,
  PriceContainer,
  Row,
  Strong,
} from "./styles";

const FinalPrices = ({ textForInstallmentAmountVisualization }) => {
  const { state } = useGlobalContext();

  const {
    steps,
    offer,
    coupon,
    installments,
    installmentOptions,
    installmentSelected,
    methodPaymentSelected,
  } = useCheckoutStepsOffersContext();

  if (steps === 0)
    return (
      <PriceContainer>
        <Strong>Total</Strong>

        <Strong>
          {offer?.offer?.details?.amount_visualization === "full" ||
          !offer?.offer?.details?.payment_methods?.credit_card
            ? formatBrazilianCurrency(Number(offer?.offer?.price))
            : textForInstallmentAmountVisualization}
        </Strong>
      </PriceContainer>
    );

  const acquirer = state?.tenancy?.acquirer;
  const IS_MIN_VALUE =
    acquirer?.complement_min_value &&
    installments[0]?.value < acquirer?.min_value;
  const HAS_VALUE_TO_PAY = installments[0]?.value > 0;

  if (methodPaymentSelected !== "credit_card") {
    return (
      <>
        {!!coupon && (
          <DiscountContainer>
            <Row>
              <Paragraph>Preço original</Paragraph>

              <Paragraph>
                {formatBrazilianCurrency(Number(offer?.offer?.price))}
              </Paragraph>
            </Row>

            <Row>
              <Paragraph>Desconto</Paragraph>

              <Discount>
                {formatBrazilianCurrency(coupon?.item?.coupon_discount_value)}
              </Discount>
            </Row>

            {IS_MIN_VALUE && HAS_VALUE_TO_PAY && (
              <>
                <Row>
                  <Paragraph>Taxa de processamento</Paragraph>

                  <Paragraph>
                    {formatBrazilianCurrency(
                      acquirer?.min_value - installments[0]?.value,
                    )}
                  </Paragraph>
                </Row>

                <Row>
                  <LittleLetters>
                    <InformationCircleSVG /> Taxa de processamento: Tarifa para
                    processar a transação e garantir que o pagamento seja
                    efetuado com segurança.
                  </LittleLetters>
                </Row>
              </>
            )}
          </DiscountContainer>
        )}

        {IS_MIN_VALUE && !coupon && (
          <>
            <DiscountContainer>
              <Row>
                <Paragraph>Valor do produto</Paragraph>

                <Paragraph>
                  {formatBrazilianCurrency(Number(offer?.offer?.price))}
                </Paragraph>
              </Row>

              <Row>
                <Paragraph>Taxa de processamento</Paragraph>

                <Paragraph>
                  {formatBrazilianCurrency(
                    acquirer?.min_value - installments[0]?.value,
                  )}
                </Paragraph>
              </Row>

              <Row>
                <LittleLetters>
                  <InformationCircleSVG /> A taxa de processamento é um
                  acréscimo para o valor total atingir 1 real e a compra ser
                  concluída.
                </LittleLetters>
              </Row>
            </DiscountContainer>
          </>
        )}

        {IS_MIN_VALUE && HAS_VALUE_TO_PAY ? (
          <PriceContainer>
            <Strong>Total</Strong>

            <Strong>{formatBrazilianCurrency(acquirer?.min_value)}</Strong>
          </PriceContainer>
        ) : (
          <PriceContainer>
            <Strong>Total</Strong>

            <Strong>{formatBrazilianCurrency(installments[0]?.value)}</Strong>
          </PriceContainer>
        )}
        <DiscountInformation />
      </>
    );
  }

  const [installmentToRender] = installmentOptions?.filter(
    (option) => option?.value === installmentSelected?.installment?.toString(),
  );

  return (
    <>
      {!!coupon && (
        <DiscountContainer>
          <Row>
            <Paragraph>Preço original</Paragraph>

            <Paragraph>
              {formatBrazilianCurrency(Number(offer?.offer?.price))}
            </Paragraph>
          </Row>

          <Row>
            <Paragraph>Desconto</Paragraph>

            <Discount>
              {formatBrazilianCurrency(coupon?.item?.coupon_discount_value)}
            </Discount>
          </Row>

          {IS_MIN_VALUE && HAS_VALUE_TO_PAY && (
            <>
              <Row>
                <Paragraph>Taxa de processamento</Paragraph>

                <Paragraph>
                  {formatBrazilianCurrency(
                    acquirer?.min_value - installments[0]?.value,
                  )}
                </Paragraph>
              </Row>

              <Row>
                <LittleLetters>
                  <InformationCircleSVG /> A taxa de processamento é um
                  acréscimo para o valor total atingir 1 real e a compra ser
                  concluída.
                </LittleLetters>
              </Row>
            </>
          )}
        </DiscountContainer>
      )}

      {IS_MIN_VALUE && !coupon && (
        <>
          <DiscountContainer>
            <Row>
              <Paragraph>Valor do produto</Paragraph>

              <Paragraph>
                {formatBrazilianCurrency(Number(offer.offer.price))}
              </Paragraph>
            </Row>

            <Row>
              <Paragraph>Taxa de processamento</Paragraph>

              <Paragraph>
                {formatBrazilianCurrency(
                  acquirer?.min_value - installments[0]?.value,
                )}
              </Paragraph>
            </Row>

            <Row>
              <LittleLetters>
                <InformationCircleSVG /> A taxa de processamento é um acréscimo
                para o valor total atingir 1 real e a compra ser concluída.
              </LittleLetters>
            </Row>
          </DiscountContainer>
        </>
      )}

      {IS_MIN_VALUE ? (
        HAS_VALUE_TO_PAY ? (
          <PriceContainer>
            <Strong>Total</Strong>

            <Strong>{formatBrazilianCurrency(acquirer?.min_value)}</Strong>
          </PriceContainer>
        ) : (
          <PriceContainer>
            <Strong>Total</Strong>

            <Strong>{formatBrazilianCurrency(installments[0]?.value)}</Strong>
          </PriceContainer>
        )
      ) : (
        <PriceContainer>
          <Strong>Total</Strong>

          <Strong>{installmentToRender?.text}</Strong>
        </PriceContainer>
      )}
      <DiscountInformation />
    </>
  );
};

export default FinalPrices;
